import styled from 'styled-components'

const sizes = {
  mini: {
    height: '35px',
    with: '130px',
    full: '100%'
  },
  small: {
    height: '50px',
    with: '80px'
  },
  medium: {
    height: '40px',
    with: '200px'
  },
  full: {
    height: '50px',
    with: '100%'
  }
}

export const Container = styled.button`
  max-width: ${(props) => sizes[props.size].with};
  width: ${(props) => sizes[props.size].with};
  height: ${(props) => sizes[props.size].height};
  outline: none !important;
  border-radius: ${(props) => props.rounded ? '999px' : null} ;
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.textColor};
  &.expansible:hover .label {
    text-decoration: underline;
  }
`
